import angular from "angular";
import appConfig from '../ConfigModule/ConfigModule';

let XdebugInterceptor = function (CONFIG) {
    /** @ngInclude */

    return {
        'request': function (config) {

            if (CONFIG.DEV && window.XDEBUG_SESSION_ID) {
                config.params = config.params || {};
                if (!(/.*\.html/.test(config.url))) {
                    config.params.XDEBUG_SESSION_START = window.XDEBUG_SESSION_ID;
                }
            }

            return config;
        }
    };
};

/**
 * Http interceptor for xdebug.
 * Detects xDebug config in app configuration (config.js) and session_id in js window property
 * to enable xDebug session. See README.md
 * @namespace cms.interceptor.xdebug
 */
export default angular.module('cms.interceptor.xdebug', [appConfig]).factory('XdebugInterceptor', XdebugInterceptor).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Xdebug/xdebugInterceptor.js